module.exports = __webpack_public_path__ + "img/The_Spotted_Cow@2x.d7536dff.webp";